module.exports = __webpack_public_path__ + "img/flow-02.7bd083e3.jpg";